const reducer = state => {
  return {
    ...state,
    giftCardValidationNonce: null,
    waiting: true,
  };
};

export default reducer;
